'use client';

import type { FC, HTMLAttributes } from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../utils/cn';

interface TextProps extends HTMLAttributes<HTMLParagraphElement> {
  weight?: '1' | '2' | '3';
  color?: 'primary' | 'secondary' | 'error' | 'success';
  caps?: boolean;
}

const textVariants = cva(
  'm-0 leading-normal',
  {
    variants: {
      weight: {
        '1': 'font-normal text-sm',
        '2': 'font-normal text-base',
        '3': 'font-medium text-base',
      },
      color: {
        primary: 'text-white',
        secondary: 'text-white/60',
        error: 'text-error',
        success: 'text-success',
      },
    },
    defaultVariants: {
      weight: '2',
      color: 'primary',
    },
  },
);

export const Text: FC<TextProps> = ({
  children,
  weight = '2',
  color = 'primary',
  caps = false,
  className,
  ...props
}) => {
  return (
    <p
      className={cn(
        textVariants({ weight, color }),
        caps && 'uppercase tracking-[0.5px]',
        className,
      )}
      {...props}
    >
      {children}
    </p>
  );
};
